import React from 'react';
import { Button, Input } from 'reactstrap';
import { AlertMessage } from '../../../../../../components/AlertMessage';
import { CopyToClipboard } from '../../../../../../components/CopyToClipboard';
import { CopyButton } from '../../../../../../components/CopyButton';

interface APIKeyDisplayProps {
  apiKeyName: string;
  token: string;
  onClose: () => void;
}

export function APIKeyDisplay({
  apiKeyName,
  token,
  onClose,
}: APIKeyDisplayProps) {
  return (
    <div>
      <div className='mb-3'>
        Here&apos;s your <strong>{apiKeyName}</strong> Key:
      </div>

      <div className='d-flex mb-3'>
        <Input value={token} className='fs-5' />
        <CopyButton
          buttonClass='ms-1 flex-shrink-0'
          hideText
          size='md'
          position='start'
          color='borderless'
          tooltipTextOnClick='Copied to clipboard.'
          textToBeCopied={token}
        />
      </div>
      <AlertMessage
        hasOverlay={false}
        icon={{ name: 'bi-info-circle' }}
        className='mb-4 mt-0 fs-5 bg-light-danger'
        text={
          <span>
            Make sure to copy and store the API key in a safe place since you
            won&apos;t be able to view it again.
          </span>
        }
      />

      <div className='d-flex mt-4 gap-3 justify-content-end'>
        <Button type='button' color='danger' onClick={onClose}>
          Close
        </Button>
        <a onClick={onClose}>
          <CopyToClipboard content={token} className='btn btn-primary' />
        </a>
      </div>
    </div>
  );
}
